import { Me } from "../../types/api-schema";
import { BROADCAST_MSG_LOGOUT } from "../../utils/constants";
import { User } from "../app/propTypes";

import type { AppAction, AppDispatch, AppThunk, RootState } from "../store";

export const OidcActionType = {
  SetBroadcast: "SET_BROADCAST",
  SetMe: "SET_ME",
  SetUser: "SET_USER",
} as const;
export type OidcActionType =
  (typeof OidcActionType)[keyof typeof OidcActionType];

export const SET_USER = OidcActionType.SetUser;
export const SET_BROADCAST = OidcActionType.SetBroadcast;
export const SET_ME = OidcActionType.SetMe;

/** Signature of `redux-thunk`'s `getState` for this app. */
export type GetState = () => RootState;

/** Signature of `redux-thunk`'s `dispatch` for this app. */
export type Dispatch = AppDispatch;

export const setUser = (data: User): AppAction => {
  return {
    data,
    type: SET_USER,
  };
};

export const setMe = (data: Me | null): AppAction => {
  return {
    data,
    type: SET_ME,
  };
};

export const setBroadcast = (data: BroadcastChannel): AppAction => {
  return {
    data,
    type: SET_BROADCAST,
  };
};

export const login = (): AppThunk => {
  return (dispatch: Dispatch, getState: GetState) => {
    const {
      app: { authUrl },
    } = getState();
    window.location.href = `${authUrl}/authenticate/?next=${encodeURIComponent(window.location.href)}`;
  };
};

export const logout = (): AppThunk => {
  return (dispatch: Dispatch, getState: GetState) => {
    const {
      app: { authUrl },
      oidc: { broadcast },
    } = getState();

    if (broadcast) {
      broadcast.postMessage(BROADCAST_MSG_LOGOUT);
    }
    window.location.href = `${authUrl}/logout`;
  };
};
